import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { subMenuItems } from '@auth/payments/submenu';
import { IServiceProfile } from '@shared/interfaces/service-profile.interface';
import { IService } from '@shared/interfaces/service.interface';
import { IToolbarItem } from '@shared/interfaces/toolbar-item.interface';
import { ApiService } from '@shared/services/api.service';
import { BookingUtilsService } from '@shared/services/booking-utils.service';
import { TokenService } from '@shared/services/token.service';
import { UtilsService } from '@shared/services/utils.service';
import { MessageService } from 'primeng/api';
import { AutoComplete } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss']
})
export class TicketsComponent {
  public subMenuItems: Array<IToolbarItem> = subMenuItems;


  @ViewChild('searcherAutocomplete') searcherAutocomplete!: AutoComplete;
  @ViewChild('selectServices') selectServices!: ElementRef;
  @ViewChild('dropdown') dropdown!: ElementRef;

  public formBooking!: FormGroup;
  public formService!: FormGroup;
  public formCustomer!: FormGroup;
  public formAddressCustomer!: FormGroup;
  public serviceData: any[] = [];
  public customerData: any[] = [];
  public addressData: any[] = [];
  public services: IService[] = [];
  public serviceId!: number;
  public servicesProfile: IServiceProfile[] = [];
  public notes: string[] = [];
  public hours!: any;
  public aliasName: any = [];
  public items: any = [];
  public ticket: any = null;
  public tickets: any[] | undefined = [];
  public selectedTicket: any | undefined;
  public ticketDetails: any[] = [];
  public userSelectedService!: any;
  public selectedCustomer: any = null;
  public selectedAddress: any = null;
  public text: string = '';
  public results: any[] = [];
  public saving: boolean = false;
  public warningMessage!: string;
  public amountBookingService: number = 0;
  public total_amount: number = 0;
  public partial_amount: number = 0;
  public multipliedValues: number[] = [];
  public selectedDate!: Date | undefined;
  public selectedCustomerFromDB: boolean = true;
  public existsServiceBooking: boolean = false;
  public placeholderTextTicketList: string = 'Seleccione un ticket';
  public hideAddCustomer = false;
  public hideAddAddress = false;




  public formSteps: { [key: string]: boolean } = {
    'customerDataForm': false,
    'addressCustomerForm': false,
  }

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private router: Router,
    public tokenService: TokenService,
    public utils: UtilsService
  ) { }

  ngOnInit() {



    // this.apiService.getCustomers().subscribe((response: any) => {
    //   this.customerData = response;
    //   this.results = this.customerData;
    // });
    this.customerData = [];

    this.apiService.getAddressList().subscribe((response: any) => {
      this.addressData = response;
    });

    if (this.route.snapshot.params['id']) {
      this.apiService.getTicketById(this.route.snapshot.params['id']).subscribe(
        (response: any) => {
          this.ticket = response?.error ? null : response;
          // this.tickets = this.tickets?.filter((ticket: any) => ticket.status != 0 && ticket.status != 2 && ticket.status != 4);

          if (this.ticket) {
            if (this.ticket.address_id) {
              this.hideAddAddress = true;
            }
            if (this.ticket.customer_id) {
              this.hideAddCustomer = true;
              this.getCustomerId(this.ticket.customer_id);
            }
            this.ticketDetails = this.ticket.details;
            this.onChangeSelectTicket(this.ticket);
          }
          // if(!isNaN(this.route.snapshot.params['id'])){
          //   this.ticket = this.tickets?.filter((ticket: any) => ticket.id == this.route.snapshot.params['id']);
          //   console.log('ticket', this.ticket);
          // }

          console.log('ticket', this.ticket);

        }
      );
    }


    this.formCustomer = this.formBuilder.group({
      name: ['', [Validators.required]],
      cif: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
    });

    this.formAddressCustomer = this.formBuilder.group({
      alias: ['Facturación'],
      street_name: ['', [Validators.required]],
      street_number: ['', [Validators.required]],
      floor: [''],
      description: [''],
      city: ['', [Validators.required]],
      province: [''],
      country: ['', [Validators.required]],
      postal_code: ['', [Validators.required]]
    });

    this.formService = this.formBuilder.group({
      services: this.formBuilder.array([]),
      items: this.formBuilder.array([]),
      date: ['', [Validators.required]],
      hour: ['', [Validators.required]],
      notes: [''],
    });

    this.hours = [];
    this.aliasName = ['Domicilio', 'Facturación', 'Comercial', 'Fiscal', 'Envío', 'Otros'];

  }

  get bookingServices() {
    return this.formService.controls["services"] as FormArray;
  }

  get bookingServicesItems() {
    return this.formService.controls["items"] as FormArray;
  }

  onChangeSelectTicket(event: any) {
    this.ticket = event.value ?? event;
    this.ticketDetails = this.ticket.details;
    this.selectedTicket = this.ticket;
    if (this.ticket.customer_id) {
      this.hideAddCustomer = true;
      this.hideAddAddress = true;
      this.getCustomerId(this.ticket.customer_id);
    } else {
      this.hideAddCustomer = false;
      this.hideAddAddress = false;
      this.selectedCustomer = null;
    }
  }

  addServiceToForm(service: any) {
    const serviceForm = this.formBuilder.group({
      service_id: [service.id, Validators.required],
      units: [0, Validators.required],
      unit_price: [service.price, Validators.required]
    });
    this.bookingServices.push(serviceForm);
  }

  addItemToForm(item: any) {
    const itemForm = this.formBuilder.group({
      id: [item.id],
      name: [item.name,],
      description: [item.description,],
      units: [0,],
      price: [item.price,]
    });
    this.bookingServicesItems.push(itemForm);

  }

  cleanFormServices() {
    this.bookingServices.clear();
  }

  onChange(value: any) {
    this.hours = [];
    this.formService.reset();
    this.cleanFormServices();
    this.partial_amount = 0;
    if (this.selectedDate !== undefined) {
      this.checkAvailability();
    }
    this.userSelectedService = this.services[value.target.value];
    this.services[value.target.value].profiles.map((item: any, index: number) => {
      this.addServiceToForm(item);
      this.calculateValue('0', index);
    });
    this.services[value.target.value].items.map((item: any, index: number) => {
      this.addItemToForm(item);
    });
  }



  isFormValid(form: FormGroup): boolean {
    return form.valid;
  }

  formatDate(date: Date): string {
    return this.datePipe.transform(date, 'dd/MM/yyyy') || '';
  }

  markFormAsTouched(form: FormGroup) {
    Object.values(form.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormAsTouched(control);
      }
    });
  }

  toggleForm(section: string) {
    this.formSteps[section] = !this.formSteps[section];
    this.warningMessage = '';
  }

  addNewNote(addNote: string) {
    this.notes.push(addNote);
  }

  increaseUnits(index: number) {
    this.ticketDetails[index].units++;
  }

  decreaseUnits(index: number) {
    if (this.ticketDetails[index].units > 1) {
      this.ticketDetails[index].units--;
    }
  }

  deleteTicketDetail(index: number) {
    if (this.ticketDetails.length > 1) {
      this.ticketDetails.splice(index, 1);
      this.calculateTotalTicket();
    }

  }

  calculateValue(inputValue: string, index: number) {
    this.multipliedValues[index] = Number.parseInt(inputValue) * this.userSelectedService.profiles[index].price;
    this.partial_amount = this.multipliedValues.reduce((acc: number, elem: number) => {
      return acc + elem;
    }, 0)
  }

  calculateTotalTicket() {
    this.total_amount = 0;
    if (this.ticketDetails) {
      this.ticketDetails.map((item: any) => {
        this.total_amount = this.total_amount + (Number.parseInt(item.units) * Number.parseFloat(item.unit_price));
      });
    }
    return this.total_amount;
  }

  saveCustomer() {
    const customerFormData = this.formCustomer.value;
    if (this.selectedCustomer) {
      if (this.isCustomerDataModified(customerFormData)) {
        this.updateCustomer(customerFormData);
      } else {
        this.toggleForm('customerDataForm');
      }
    } else {
      this.createCustomer(customerFormData);
    }
  }

  createCustomer(customerData: any) {
    this.apiService.post('/customer/create', customerData).subscribe(
      (response: any) => {
        this.selectedCustomer = response;
        this.selectedCustomer.addresses = [];
        this.toggleForm('customerDataForm')
      },
      (error) => {
        console.log('Error al crear cliente', error);
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  updateCustomer(customerData: any) {
    this.apiService.post(`/customer/update/${this.selectedCustomer.id}`, customerData).subscribe(
      (response: any) => {
        this.selectedCustomer = { ...this.selectedCustomer, ...customerData };
        this.toggleForm('customerDataForm')
      },
      (error) => {
        console.log('error actualizar cliente', error);
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  search(event: any) {
    const query = event.query;
    if (this.customerData && this.customerData.length > 0) {
      this.results = this.customerData.filter((customer: { name: string; email: string; }) =>
        customer && customer?.name?.toLowerCase().includes(query.toLowerCase()) ||
        customer && customer?.email?.toLowerCase().includes(query.toLowerCase())
      );
    } else {
      this.results = [];
    }
  }

  searchCustomer(event: any) {
    const query = event.query;
    if (query && query.length > 2) {
      this.apiService.getCustomersPaginated(query).subscribe((response: any) => {
        this.results = response;
      });
    } else {
      this.results = [];
    }
  }

  onSelect(event: any) {
    this.selectedCustomer = event.value ?? event;
    this.selectedCustomerFromDB = true;
    this.formCustomer.patchValue({
      name: this.selectedCustomer.name,
      cif: this.selectedCustomer.cif,
      phone: this.selectedCustomer.phone,
      email: this.selectedCustomer.email
    });
    this.getCustomerId(this.selectedCustomer.id);
  }

  getCustomerId(customerId: number) {
    this.apiService.getCustomerById(customerId).subscribe((response: any) => {
      this.selectedCustomer = response;
      this.selectedAddress = this.selectedCustomer.addresses[0];
    })
  }

  isCustomerDataModified(data: any): boolean {
    return (
      data.name !== this.selectedCustomer.name ||
      data.cif !== this.selectedCustomer.cif ||
      data.phone !== this.selectedCustomer.phone ||
      data.email !== this.selectedCustomer.email
    );
  }

  saveAddressCustomer() {
    const addressNewData = this.formAddressCustomer.value;
    if (this.selectedCustomer) {
      if (this.selectedAddress) {
        const index = this.selectedCustomer.addresses.indexOf(this.selectedAddress);
        if (index !== -1) {
          this.updateAddress(this.selectedAddress);
        }
      } else {
        this.createAddress(addressNewData);
      }
      if (this.isFormValid(this.formAddressCustomer)) {
        this.formAddressCustomer.reset();
        this.toggleForm('addressCustomerForm');
      }
    } else {
      this.warningMessage = '¡Necesitas seleccionar un cliente!';
    }
  }

  updateAddress(customerAddressData: any) {
    const addressId = customerAddressData.id;
    this.apiService.post(`/address/update/${addressId}`, this.formAddressCustomer.value).subscribe(
      (response: any) => {
        const index = this.selectedCustomer.addresses.indexOf(this.selectedAddress);
        if (index !== -1) {
          this.selectedCustomer.addresses[index] = response.address;
          this.selectedAddress = response.address;
        }
      },
      (error) => {
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  createAddress(customerAddressData: any) {
    this.apiService.post(`/address/create/${this.selectedCustomer.id}`, customerAddressData).subscribe(
      (response: any) => {
        this.selectedAddress = response.address;
        this.selectedCustomer.addresses.push(response.address);
      },
      (error) => {
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  editAddress(address: any) {
    this.selectedAddress = address;
    this.formAddressCustomer.patchValue(address);
    this.toggleForm('addressCustomerForm');
  }

  deleteAddress(address: any) {
    if (this.selectedCustomer) {
      const index = this.selectedCustomer.addresses.indexOf(address);
      if (index !== -1) {
        this.apiService.post(`/address/delete/${address.id}`, address).subscribe(
          (response: any) => {
          },
          (error) => {
            if (error && error.error && error.error.data) {
              this.handleValidationErrors(error.error.data);
            }
          }
        );
        this.selectedCustomer.addresses.splice(index, 1);
        this.selectedAddress = null;
      }
    }
  }

  getBillingAddress() {
    return BookingUtilsService.getBillingAddress(this.selectedCustomer)
  }

  isValidTicket() {
    if (this.selectedCustomer !== undefined && this.selectedCustomer !== null && this.ticketDetails !== undefined && this.ticketDetails.length > 0) {

      return true;
    }
    return false;
  }

  saveInvoiceTicket() {
    if (!this.selectedCustomer) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Por favor, selecciona un cliente.' });
      return;
    }

    if (!this.selectedAddress) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Por favor, selecciona una dirección.' });
      return;
    }

    if (this.ticketDetails.length === 0) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Por favor, seleccione un ticket con lista de detalles.' });
      return;
    }
    this.saving = true;
    this.calculateTotalTicket();

    const ticketData = {
      customer_id: this.selectedCustomer.id,
      address_id: this.selectedAddress.id,
    };

    const ticketDetails = {
      details: this.ticketDetails
    };

    this.apiService.updateFieldsTicket(this.ticket.id, ticketData).subscribe((response: any) => {

      if (response.address_id) {
        this.hideAddCustomer = true;
      }
      if (response.customer_id) {
        this.hideAddAddress = true;
      }

      this.apiService.getTicketById(this.ticket.id).subscribe((response: any) => {
        this.ticket = response;

        console.log(this.ticket);

        if (this.ticket.customer_id) {
          this.hideAddCustomer = true;
          this.getCustomerId(this.ticket.customer_id);
        }
        this.ticketDetails = this.ticket.details;
        this.onChangeSelectTicket(this.ticket);
      });
      const params = new HttpParams().set('details', JSON.stringify(this.ticket.details));
      window.open(`${environment.baseUrlWeb}/invoices/ticket/generate/${this.ticket.id}?${params.toString()}&token=${this.tokenService.getToken()}`, '_blank');

    });
    this.saving = false;


  }

  selectDate(event: any) {
    this.selectedDate = event.target.value;
    this.checkAvailability();
  }

  checkAvailability() {
    this.apiService.getAvailability(this.userSelectedService.id, this.selectedDate as Date).subscribe((result: any) => {
      if (result.availability) {
        this.hours = result.timetable;
      } else {
        alert(result.message);
      }
    });
  }

  handleValidationErrors(validationData: any) {
    Object.keys(validationData).forEach(key => {
      const errorMessages = validationData[key];
      const messageToast = ` ${errorMessages.join(", ")}`;
      this.messageService.add({ severity: 'error', summary: 'Error de validación', detail: messageToast, life: 30000 });
    });
  }
}
